import { render, staticRenderFns } from "./SlideEditProduct.vue?vue&type=template&id=d127dc22&scoped=true&"
import script from "./SlideEditProduct.vue?vue&type=script&lang=js&"
export * from "./SlideEditProduct.vue?vue&type=script&lang=js&"
import style0 from "./SlideEditProduct.vue?vue&type=style&index=0&id=d127dc22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d127dc22",
  null
  
)

export default component.exports